<!-- 设置下拉数据 -->
<template>
  <div>
    <el-dialog
      width="800px"
      title="设置下拉数据"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="popup-main">
        <e-form ref="refForm" :column="formColumn" :data.sync="selfData" />
        <vxe-grid
          :height="408"
          :toolbar-config="tableConfig.toolbarConfig"
          :row-config="tableConfig.rowConfig"
          :keyboard-config="tableConfig.keyboardConfig"
          :columns="tableColumn"
          :data="selfData.set_options"
        >
          <!-- slot_default -->
          <template #default_key="{ row }">
            <el-input size="mini" v-model="row.key" clearable />
          </template>
          <template #default_val="{ row }">
            <el-input size="mini" v-model="row.val" clearable />
          </template>
          <template #default_do="{ rowIndex }">
            <el-link type="success" @click="rowAdd">增行</el-link>
            <el-link type="danger" @click="rowDelete(rowIndex)"> 删行 </el-link>
          </template>
          <!-- 数据为空 -->
          <template #empty>
            <div class="flex flex-center">
              <span class="f-s-14 c-gray-light">暂无数据</span>
              <el-link class="m-l-10" type="success" @click="rowAdd">增行</el-link>
            </div>
          </template>
        </vxe-grid>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selfShow: false,
      selfData: {},
      formColumn: [
        {
          type: 'text',
          field: 'name',
          title: '字段名称',
          width: '100%',
          required: true,
          disabled: true
        },
        {
          type: 'text',
          field: 'lei_xing_str',
          title: '字段类型',
          width: '100%',
          required: true,
          disabled: true
        }
      ],
      tableColumn: [
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 40
        },
        {
          title: '下拉键',
          field: 'key',
          slots: { default: 'default_key' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '下拉值',
          field: 'val',
          slots: { default: 'default_val' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '操作',
          slots: { default: 'default_do' }
        }
      ]
    }
  },
  computed: {
    // 表格配置合并
    tableConfig() {
      let obj = {}
      let result = this.$util.deepMerge(this.$constant.tableDefaultConfig, obj)
      return result
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    this.initSelfData()
  },
  methods: {
    // 初始化数据
    initSelfData() {
      let result = this.$util.deepCopy(this.data)
      if (!result.set_options.length) {
        result.set_options.push({ key: '', val: '' })
      }
      this.selfData = result
    },
    // 增行-价格
    rowAdd() {
      let result = {
        key: '',
        val: ''
      }
      this.selfData.set_options.push(result)
    },
    // 删行-价格
    rowDelete(index) {
      this.selfData.set_options.splice(index, 1)
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      let result = this.selfData.set_options.filter((item) => {
        return item.key && item.val
      })
      this.selfData.set_options = result
      this.$emit('update:data', this.selfData)
      this.popupCancel()
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
}
</style>
